var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspecialidadNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0.5C22.69 0.5 23.25 1.06 23.25 1.75V24.25C23.25 24.94 22.69 25.5 22 25.5H4.5C3.81 25.5 3.25 24.94 3.25 24.25V21.75H0.75V19.25H3.25V16.75H0.75V14.25H3.25V11.75H0.75V9.25H3.25V6.75H0.75V4.25H3.25V1.75C3.25 1.06 3.81 0.5 4.5 0.5H22ZM20.75 3H5.75V23H20.75V3ZM14.5 8V11.75H18.25V14.25H14.4987L14.5 18H12L11.9987 14.25H8.25V11.75H12V8H14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspecialidadNav);
export default __webpack_public_path__ + "static/media/especialidadNav.85d7b6a2dc7bd8a36977976c4c8224ad.svg";
export { ForwardRef as ReactComponent };